import React, { useContext, useEffect, useState } from 'react'
import { DashBoardSectionBlock, DashBoardSectionBlockSubTitle, DashBoardSectionBlockTitle, Row } from '..'
import Spacer from 'src/common/components/Spacer'
import { useNavigate } from 'react-router-dom'
import { SearchInput } from 'src/common/components/SearchInput'
import { SortHeader } from 'src/pages/groups'
import UserAvatar from 'src/common/components/UserAvatar'
import userService from 'src/services/user.service'
import LoadingIndicator from 'src/common/components/LoadingIndicator'
import { UserViewContext } from 'src/App'
import useDebounce from 'src/hooks'

export function RiskyIndividuals() {
  const navigate = useNavigate()

  const [loading, setloading] = useState(true)
  const [repeatFailUsers, setRepeatFailUsers] = useState([])
  const [search, setSearch] = useState('')

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [userViewId, setUserViewId] = useContext(UserViewContext)

  useEffect(() => {
    setloading(true)
    Promise.all([
      userService.getUsers({
        size: 50,
        sort: 'failRate,desc',
        status: 'ACTIVE'
      })
    ])
      .then(values => {
        const [usersResp] = values
        setRepeatFailUsers(usersResp.data)
        setloading(false)
      })
      .catch(err => {
        console.error(err)
        setloading(false)
      })
  }, [])

  const onFillter = str => {
    setloading(true)
    Promise.all([
      userService.getUsers({
        size: 50,
        sort: 'failRate,desc',
        searchText: str
      })
    ])
      .then(values => {
        const [usersResp] = values
        setRepeatFailUsers(usersResp.data)
        setloading(false)
      })
      .catch(err => {
        console.error(err)
        setloading(false)
      })
  }

  const debouncedSearchTerm = useDebounce(search, 500)

  useEffect(() => {
    if (debouncedSearchTerm) {
      onFillter(search)
    } else {
      onFillter('')
    }
  }, [debouncedSearchTerm])

  return (
    <div
      className='column'
      style={{
        backgroundColor: '#F8F8FB',
        height: '100vh',
        overflowY: 'auto',
        padding: '24px'
      }}
    >
      <div className='container-1030' style={{ height: '100vh' }}>
        <div
          className='row row-center'
          onClick={() => navigate('/phishing-click-rate')}
          style={{ marginBottom: 14, cursor: 'pointer' }}
        >
          <svg width='17' height='16' viewBox='0 0 17 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M16 8.25H1.75' stroke='#6123FF' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
            <path
              d='M8.5 15L1.75 8.25L8.5 1.5'
              stroke='#6123FF'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>

          <p style={{ color: '#6123FF', marginLeft: 8 }}>Back to Phishing click rate</p>
        </div>
        <div className='row row-center'>
          <h1>Risk analysis individuals</h1>
          <div className='row'></div>
        </div>

        <DashBoardSectionBlock style={{ width: '100%' }}>
          <Row>
            <div className='column' style={{ marginBottom: 48 }}>
              <DashBoardSectionBlockTitle>Riskiest list</DashBoardSectionBlockTitle>
              {/* <DashBoardSectionBlockSubTitle>30% Up since for last 3 month</DashBoardSectionBlockSubTitle> */}
            </div>
            <Spacer />
            <SearchInput placeholder='Search by Individuals' value={search} onChange={setSearch} />
          </Row>

          {loading ? (
            <LoadingIndicator />
          ) : (
            <div className='column'>
              <div className='row groups-list-heading' style={{ marginBottom: 8 }}>
                <SortHeader disabled={true} name={'Individual'} onSort={() => {}} width={'25%'} />
                <SortHeader disabled={true} name={'Human risk score'} onSort={() => {}} width={'17%'} />
                <SortHeader disabled={true} name={'Department'} onSort={() => {}} width={'15%'} />
                <SortHeader disabled={true} name={'Email'} onSort={() => {}} width={'25%'} />
                <SortHeader disabled={true} name={'Location'} onSort={() => {}} width={'8%'} />
              </div>

              {repeatFailUsers?.map((el, i) => (
                <div
                  onClick={() => setUserViewId(el.id)}
                  key={el.id}
                  style={{
                    cursor: 'pointer',
                    paddingBottom: 10,
                    borderBottom: '1px solid #E7E8EAb3',
                    marginBottom: 10
                  }}
                  className='row row-center'
                >
                  <div className='row row-center' style={{ width: '25%' }}>
                    <p style={{ marginRight: 10 }} className='secondary-text-16'>
                      #{i + 1}
                    </p>
                    <UserAvatar
                      style={{
                        width: '36px',
                        height: '36px'
                      }}
                      id={el?.id}
                      firstName={el?.firstName}
                      lastName={el?.lastName}
                    />
                    <p
                      className='text-ellipsis'
                      style={{
                        fontWeight: 600,
                        marginRight: 10
                      }}
                    >
                      {el?.firstName || 'unknown'} {el?.lastName || 'unknown'}
                    </p>
                  </div>
                  <div className='row row-center' style={{ width: '17%' }}>
                    <div
                      style={{
                        position: 'relative',
                        marginRight: 10
                      }}
                    >
                      <svg width='106' height='8' viewBox='0 0 106 8' fill='none' xmlns='http://www.w3.org/2000/svg'>
                        <path
                          fillRule='evenodd'
                          clipRule='evenodd'
                          d='M0 4C0 3.07003 0 2.60504 0.102223 2.22354C0.379624 1.18827 1.18827 0.379624 2.22354 0.102223C2.60504 0 3.07003 0 4 0H14C14.93 0 15.395 0 15.7765 0.102223C16.8117 0.379624 17.6204 1.18827 17.8978 2.22354C18 2.60504 18 3.07003 18 4C18 4.92997 18 5.39496 17.8978 5.77646C17.6204 6.81173 16.8117 7.62038 15.7765 7.89778C15.395 8 14.93 8 14 8H4C3.07003 8 2.60504 8 2.22354 7.89778C1.18827 7.62038 0.379624 6.81173 0.102223 5.77646C0 5.39496 0 4.92997 0 4ZM22 4C22 3.07003 22 2.60504 22.1022 2.22354C22.3796 1.18827 23.1883 0.379624 24.2235 0.102223C24.605 0 25.07 0 26 0H36C36.93 0 37.395 0 37.7765 0.102223C38.8117 0.379624 39.6204 1.18827 39.8978 2.22354C40 2.60504 40 3.07003 40 4C40 4.92997 40 5.39496 39.8978 5.77646C39.6204 6.81173 38.8117 7.62038 37.7765 7.89778C37.395 8 36.93 8 36 8H26C25.07 8 24.605 8 24.2235 7.89778C23.1883 7.62038 22.3796 6.81173 22.1022 5.77646C22 5.39496 22 4.92997 22 4ZM44.1022 2.22354C44 2.60504 44 3.07003 44 4C44 4.92997 44 5.39496 44.1022 5.77646C44.3796 6.81173 45.1883 7.62038 46.2235 7.89778C46.605 8 47.07 8 48 8H58C58.93 8 59.395 8 59.7765 7.89778C60.8117 7.62038 61.6204 6.81173 61.8978 5.77646C62 5.39496 62 4.92997 62 4C62 3.07003 62 2.60504 61.8978 2.22354C61.6204 1.18827 60.8117 0.379624 59.7765 0.102223C59.395 0 58.93 0 58 0H48C47.07 0 46.605 0 46.2235 0.102223C45.1883 0.379624 44.3796 1.18827 44.1022 2.22354ZM66 4C66 3.07003 66 2.60504 66.1022 2.22354C66.3796 1.18827 67.1883 0.379624 68.2235 0.102223C68.605 0 69.07 0 70 0H80C80.93 0 81.395 0 81.7765 0.102223C82.8117 0.379624 83.6204 1.18827 83.8978 2.22354C84 2.60504 84 3.07003 84 4C84 4.92997 84 5.39496 83.8978 5.77646C83.6204 6.81173 82.8117 7.62038 81.7765 7.89778C81.395 8 80.93 8 80 8H70C69.07 8 68.605 8 68.2235 7.89778C67.1883 7.62038 66.3796 6.81173 66.1022 5.77646C66 5.39496 66 4.92997 66 4ZM88.1022 2.22354C88 2.60504 88 3.07003 88 4C88 4.92997 88 5.39496 88.1022 5.77646C88.3796 6.81173 89.1883 7.62038 90.2235 7.89778C90.605 8 91.07 8 92 8H102C102.93 8 103.395 8 103.776 7.89778C104.812 7.62038 105.62 6.81173 105.898 5.77646C106 5.39496 106 4.92997 106 4C106 3.07003 106 2.60504 105.898 2.22354C105.62 1.18827 104.812 0.379624 103.776 0.102223C103.395 0 102.93 0 102 0H92C91.07 0 90.605 0 90.2235 0.102223C89.1883 0.379624 88.3796 1.18827 88.1022 2.22354Z'
                          fill='#F4F5F9'
                        />
                        <defs>
                          <linearGradient
                            id='paint0_linear_515_4586'
                            x1='76.5556'
                            y1='-7.56484e-06'
                            x2='0.443036'
                            y2='17.8854'
                            gradientUnits='userSpaceOnUse'
                          >
                            <stop stopColor='#F54F1B' />
                            <stop offset='1' stopColor='#F68428' />
                          </linearGradient>
                        </defs>
                      </svg>

                      <div
                        style={{
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          width: Math.round(el?.failRate * 10) + '0%',
                          overflow: 'hidden'
                        }}
                      >
                        <svg width='106' height='8' viewBox='0 0 106 8' fill='none' xmlns='http://www.w3.org/2000/svg'>
                          <path
                            fillRule='evenodd'
                            clipRule='evenodd'
                            d='M0 4C0 3.07003 0 2.60504 0.102223 2.22354C0.379624 1.18827 1.18827 0.379624 2.22354 0.102223C2.60504 0 3.07003 0 4 0H14C14.93 0 15.395 0 15.7765 0.102223C16.8117 0.379624 17.6204 1.18827 17.8978 2.22354C18 2.60504 18 3.07003 18 4C18 4.92997 18 5.39496 17.8978 5.77646C17.6204 6.81173 16.8117 7.62038 15.7765 7.89778C15.395 8 14.93 8 14 8H4C3.07003 8 2.60504 8 2.22354 7.89778C1.18827 7.62038 0.379624 6.81173 0.102223 5.77646C0 5.39496 0 4.92997 0 4ZM22 4C22 3.07003 22 2.60504 22.1022 2.22354C22.3796 1.18827 23.1883 0.379624 24.2235 0.102223C24.605 0 25.07 0 26 0H36C36.93 0 37.395 0 37.7765 0.102223C38.8117 0.379624 39.6204 1.18827 39.8978 2.22354C40 2.60504 40 3.07003 40 4C40 4.92997 40 5.39496 39.8978 5.77646C39.6204 6.81173 38.8117 7.62038 37.7765 7.89778C37.395 8 36.93 8 36 8H26C25.07 8 24.605 8 24.2235 7.89778C23.1883 7.62038 22.3796 6.81173 22.1022 5.77646C22 5.39496 22 4.92997 22 4ZM44.1022 2.22354C44 2.60504 44 3.07003 44 4C44 4.92997 44 5.39496 44.1022 5.77646C44.3796 6.81173 45.1883 7.62038 46.2235 7.89778C46.605 8 47.07 8 48 8H58C58.93 8 59.395 8 59.7765 7.89778C60.8117 7.62038 61.6204 6.81173 61.8978 5.77646C62 5.39496 62 4.92997 62 4C62 3.07003 62 2.60504 61.8978 2.22354C61.6204 1.18827 60.8117 0.379624 59.7765 0.102223C59.395 0 58.93 0 58 0H48C47.07 0 46.605 0 46.2235 0.102223C45.1883 0.379624 44.3796 1.18827 44.1022 2.22354ZM66 4C66 3.07003 66 2.60504 66.1022 2.22354C66.3796 1.18827 67.1883 0.379624 68.2235 0.102223C68.605 0 69.07 0 70 0H80C80.93 0 81.395 0 81.7765 0.102223C82.8117 0.379624 83.6204 1.18827 83.8978 2.22354C84 2.60504 84 3.07003 84 4C84 4.92997 84 5.39496 83.8978 5.77646C83.6204 6.81173 82.8117 7.62038 81.7765 7.89778C81.395 8 80.93 8 80 8H70C69.07 8 68.605 8 68.2235 7.89778C67.1883 7.62038 66.3796 6.81173 66.1022 5.77646C66 5.39496 66 4.92997 66 4ZM88.1022 2.22354C88 2.60504 88 3.07003 88 4C88 4.92997 88 5.39496 88.1022 5.77646C88.3796 6.81173 89.1883 7.62038 90.2235 7.89778C90.605 8 91.07 8 92 8H102C102.93 8 103.395 8 103.776 7.89778C104.812 7.62038 105.62 6.81173 105.898 5.77646C106 5.39496 106 4.92997 106 4C106 3.07003 106 2.60504 105.898 2.22354C105.62 1.18827 104.812 0.379624 103.776 0.102223C103.395 0 102.93 0 102 0H92C91.07 0 90.605 0 90.2235 0.102223C89.1883 0.379624 88.3796 1.18827 88.1022 2.22354Z'
                            fill='#F4F5F9'
                          />
                          <path
                            fillRule='evenodd'
                            clipRule='evenodd'
                            d='M0 4C0 3.07003 0 2.60504 0.102223 2.22354C0.379624 1.18827 1.18827 0.379624 2.22354 0.102223C2.60504 0 3.07003 0 4 0H14C14.93 0 15.395 0 15.7765 0.102223C16.8117 0.379624 17.6204 1.18827 17.8978 2.22354C18 2.60504 18 3.07003 18 4C18 4.92997 18 5.39496 17.8978 5.77646C17.6204 6.81173 16.8117 7.62038 15.7765 7.89778C15.395 8 14.93 8 14 8H4C3.07003 8 2.60504 8 2.22354 7.89778C1.18827 7.62038 0.379624 6.81173 0.102223 5.77646C0 5.39496 0 4.92997 0 4ZM22 4C22 3.07003 22 2.60504 22.1022 2.22354C22.3796 1.18827 23.1883 0.379624 24.2235 0.102223C24.605 0 25.07 0 26 0H36C36.93 0 37.395 0 37.7765 0.102223C38.8117 0.379624 39.6204 1.18827 39.8978 2.22354C40 2.60504 40 3.07003 40 4C40 4.92997 40 5.39496 39.8978 5.77646C39.6204 6.81173 38.8117 7.62038 37.7765 7.89778C37.395 8 36.93 8 36 8H26C25.07 8 24.605 8 24.2235 7.89778C23.1883 7.62038 22.3796 6.81173 22.1022 5.77646C22 5.39496 22 4.92997 22 4ZM44.1022 2.22354C44 2.60504 44 3.07003 44 4C44 4.92997 44 5.39496 44.1022 5.77646C44.3796 6.81173 45.1883 7.62038 46.2235 7.89778C46.605 8 47.07 8 48 8H58C58.93 8 59.395 8 59.7765 7.89778C60.8117 7.62038 61.6204 6.81173 61.8978 5.77646C62 5.39496 62 4.92997 62 4C62 3.07003 62 2.60504 61.8978 2.22354C61.6204 1.18827 60.8117 0.379624 59.7765 0.102223C59.395 0 58.93 0 58 0H48C47.07 0 46.605 0 46.2235 0.102223C45.1883 0.379624 44.3796 1.18827 44.1022 2.22354ZM66 4C66 3.07003 66 2.60504 66.1022 2.22354C66.3796 1.18827 67.1883 0.379624 68.2235 0.102223C68.605 0 69.07 0 70 0H80C80.93 0 81.395 0 81.7765 0.102223C82.8117 0.379624 83.6204 1.18827 83.8978 2.22354C84 2.60504 84 3.07003 84 4C84 4.92997 84 5.39496 83.8978 5.77646C83.6204 6.81173 82.8117 7.62038 81.7765 7.89778C81.395 8 80.93 8 80 8H70C69.07 8 68.605 8 68.2235 7.89778C67.1883 7.62038 66.3796 6.81173 66.1022 5.77646C66 5.39496 66 4.92997 66 4ZM88.1022 2.22354C88 2.60504 88 3.07003 88 4C88 4.92997 88 5.39496 88.1022 5.77646C88.3796 6.81173 89.1883 7.62038 90.2235 7.89778C90.605 8 91.07 8 92 8H102C102.93 8 103.395 8 103.776 7.89778C104.812 7.62038 105.62 6.81173 105.898 5.77646C106 5.39496 106 4.92997 106 4C106 3.07003 106 2.60504 105.898 2.22354C105.62 1.18827 104.812 0.379624 103.776 0.102223C103.395 0 102.93 0 102 0H92C91.07 0 90.605 0 90.2235 0.102223C89.1883 0.379624 88.3796 1.18827 88.1022 2.22354Z'
                            fill='url(#paint0_linear_515_4586)'
                          />
                          <defs>
                            <linearGradient
                              id='paint0_linear_515_4586'
                              x1='76.5556'
                              y1='-7.56484e-06'
                              x2='0.443036'
                              y2='17.8854'
                              gradientUnits='userSpaceOnUse'
                            >
                              <stop stopColor='#F54F1B' />
                              <stop offset='1' stopColor='#F68428' />
                            </linearGradient>
                          </defs>
                        </svg>
                      </div>
                    </div>
                    <p style={{ fontWeight: 600 }}>{(el?.failRate * 10).toFixed(1)}</p>
                  </div>
                  <div className='row row-center' style={{ width: '15%' }}>
                    <p>{el?.department}</p>
                  </div>
                  <div
                    className='row row-center'
                    style={{
                      width: '25%',
                      overflow: 'hidden'
                    }}
                  >
                    <p className='text-ellipsis'>{el?.email}</p>
                  </div>
                  <div
                    className='row row-center'
                    style={{
                      width: '8%',
                      padding: '0px 8px'
                    }}
                  >
                    <p>{el?.country}</p>
                  </div>
                  <Spacer />
                </div>
              ))}
            </div>
          )}
        </DashBoardSectionBlock>
      </div>
    </div>
  )
}
